<template>
    <div class="el-card  pd20 special">
        <el-divider></el-divider>
        <!-- form -->
        <el-form  :model="form"  :rules="rules" ref="form" >
            <!-- 海报名称 -->
            <el-form-item label="海报名称" prop="name"  :label-width="formLabelWidth">
                <el-input  v-model="form.name" placeholder="请输入海报名称" ></el-input>
            </el-form-item>
            <!-- 背景图 -->
            <el-form-item  label="背景图" prop="image_id" :label-width="formLabelWidth">
                <el-upload
                    class="upload-demo"
                    :show-file-list="false"
                    :http-request="uploadImg"
                    :before-upload="beforeAvatarUpload">
                    <el-button  size="small" type="primary">点击上传</el-button>
                </el-upload>
                <!--  -->
                <el-image v-if="bgImg" class="up-image" :src="bgImg">
                    <div slot="placeholder" class="image-slot">
                        加载中<span class="dot">...</span>
                    </div>
                    <div slot="error" :style="{height:'150px','line-height':'150px'}" class="image-slot error">
                        请上传图片...
                    </div>
                </el-image>
            </el-form-item>
            <!-- 关联活动 -->
            <el-form-item label="关联活动" prop="activity_id"  :label-width="formLabelWidth">
                <el-select v-model="form.activity_id" class="price" placeholder="请选择关联活动">
                    <el-option
                    v-for="item in activityArr"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <!-- 头像位置 -->
            <el-form-item label="头像位置"   :label-width="formLabelWidth">
                <el-input  v-model="qrCodeObj.head_pos" placeholder="请输入头像位置" ></el-input>
            </el-form-item>
            <!-- 头像大小 -->
            <el-form-item label="头像大小"   :label-width="formLabelWidth">
                <el-input  v-model="qrCodeObj.head_size" placeholder="请输入头像大小" ></el-input>
            </el-form-item>
            <!-- 昵称位置 -->
            <el-form-item label="昵称位置"   :label-width="formLabelWidth">
                <el-input  v-model="qrCodeObj.nickname_pos" placeholder="请输入昵称位置" ></el-input>
            </el-form-item>
            <!-- 昵称宽度 -->
            <el-form-item label="昵称宽度"   :label-width="formLabelWidth">
                <el-input  v-model="qrCodeObj.nickname_width" placeholder="请输入昵称宽度" ></el-input>
            </el-form-item>
            <!-- 昵称颜色 -->
            <el-form-item label="昵称颜色"   :label-width="formLabelWidth">
                <el-input  v-model="qrCodeObj.nickname_color" placeholder="请输入昵称颜色" ></el-input>
            </el-form-item>
            <!-- 昵称大小 -->
            <el-form-item label="昵称大小"   :label-width="formLabelWidth">
                <el-input  v-model="qrCodeObj.nickname_size" placeholder="请输入昵称大小" ></el-input>
            </el-form-item>
            <!-- 是否上传二维码 -->
            <el-form-item label="是否上传二维码"   :label-width="formLabelWidth">
                <el-select v-model="qrCodeObj.qrcode_enable" class="price" placeholder="请选择">
                    <el-option  label="是" :value="true"></el-option>
                    <el-option  label="否" :value="false"></el-option>
                </el-select>
            </el-form-item>
            <!-- 二维码位置 -->
            <el-form-item v-if="qrCodeObj.qrcode_enable" label="二维码位置"   :label-width="formLabelWidth">
                <el-input  v-model="qrCodeObj.qrcode_pos" placeholder="请输入二维码位置" ></el-input>
            </el-form-item>
            <!-- 二维码大小 -->
            <el-form-item v-if="qrCodeObj.qrcode_enable" label="二维码大小"   :label-width="formLabelWidth">
                <el-input  v-model="qrCodeObj.qrcode_size" placeholder="请输入二维码大小" ></el-input>
            </el-form-item>

            <!-- 状态 -->
            <el-form-item label="状态" prop="status"  :label-width="formLabelWidth">
                <el-select v-model="form.status" class="price" placeholder="请选择状态">
                    <el-option  label="未生效" :value="0"></el-option>
                    <el-option  label="生效" :value="1"></el-option>
                </el-select>
            </el-form-item>

            <!-- 排序 -->
            <el-form-item label="排序" prop="sort"  :label-width="formLabelWidth">
                <el-input  v-model="form.sort" placeholder="请输入排序值" ></el-input>
            </el-form-item>
            
            
            <!--  -->
            <el-form-item style="text-align:center;"  :label-width="formLabelWidth">
                <el-button    @click="$router.go(-1)"  size="medium">取消</el-button>
                <el-button type="primary" @click="submitForm('form')" size="medium" >保存</el-button>
                <el-button type="primary" @click="previewPosterHandle()"  size="medium">预览</el-button>
            </el-form-item>
        </el-form>
        <!-- 预览 -->
       <el-dialog title="预览海报" :visible.sync="bool">
            <el-image v-if="previewPosterStr" class="previewimage" :src="previewPosterStr">
                <div slot="placeholder" class="image-slot">
                    加载中<span class="dot">...</span>
                </div>
            </el-image>
            <div slot="footer" class="dialog-footer">
                <el-button @click="bool = false">关 闭</el-button>
            </div>
        </el-dialog>
    </div>
</template> 

<script>
import { getPoster,activityAll,upload_image,addPoster,updatePoster,parseComponents,createComponents,previewPoster } from "@/api/operating";
export default {
    data() {
        return{
            formLabelWidth:'120px',
            list:[],
            activityArr:[],
            form:{
                name:'',
                activity_id:null,
                image_id:null,
                status:null,
                sort:null
            },
            bgImg:'',
            qrCodeObj:{
                qrcode_enable:false,
                head_pos:'',
                head_size:'',
                nickname_pos:'',
                nickname_width:'',
                nickname_color:'',
                nickname_size:'',
                qrcode_pos:'',
                qrcode_size:''
            },
            // 预览海报
            bool:false,
            previewPosterStr:'',
            //这是一个验证规则
            rules:{
                name:[{
                    required: true,
                    message: '请输入海报名称',
                    trigger: 'blur'
                }],
                 image_id:[{
                    required: true,
                    message: '请上传背景图',
                    trigger: ['blur','change']
                }],
                status:[{
                    required: true,
                    message: '请输入状态',
                    trigger: ['blur','change']
                }],
                sort:[{
                    required: true,
                    message: '请输入排序值',
                    trigger: 'blur'
                }],
                activity_id:[{
                    required: true,
                    message: '请输入选择活动',
                    trigger: ['blur','change']
                }],
                head_pos:[{
                    required: true,
                    message: '请输入头像位置',
                    trigger: 'blur'
                }],
                head_size:[{
                    required: true,
                    message: '请输入头像大小',
                    trigger: 'blur'
                }],
                nickname_pos:[{
                    required: true,
                    message: '请输入昵称位置',
                    trigger: 'blur'
                }],
                nickname_width:[{
                    required: true,
                    message: '请输入昵称宽度',
                    trigger: 'blur'
                }],
                nickname_color:[{
                    required: true,
                    message: '请输入昵称颜色',
                    trigger: 'blur'
                }],
                nickname_size:[{
                    required: true,
                    message: '请输入昵称大小',
                    trigger: 'blur'
                }]

            }
        }
    },
    methods:{
        // 预览海报
        previewPosterHandle(){

            createComponents({
                activity_id:this.form.activity_id,
                params:JSON.stringify(this.qrCodeObj)
            }).then(res=>{
                 
                let argu = {
                    head:'https://uploads-cdn.xjy.cn/2016/07/19/578dfdf6485f9.png',
                    nickname:'古典古少侠',
                    qrcode:'https://coach.xjy.cn/upload/admin/20190903/f9396a26e1e3c069efecea16ebf0290e.png'
                }; 
                previewPoster({
                    image_id:this.form.image_id,
                    components:res.components,
                    arguments:JSON.stringify(argu)
                }).then(data=>{
                    if(data.error >0){
                        this.$message(data.msg);
                        return
                    }
                    this.previewPosterStr = data.image_url;
                    this.bool = true;
                });
            });
            
        },
        // 提交数据
        save(){
            if(this.$route.query.id){
                // 修改
                updatePoster(this.form).then((data)=>{
                    if(data.error >0){
                        this.$message(data.msg);
                        return
                    }
                    this.$notify({
                        title: '成功',
                        message: '修改成功！',
                        type: 'success'
                    });
                    this.$router.go(-1);
                });
            }else{
                // 添加
                addPoster(this.form).then((data)=>{
                    if(data.error >0){
                        this.$message(data.msg);
                        return
                    }
                    this.$notify({
                        title: '成功',
                        message: '添加成功！',
                        type: 'success'
                    });
                    this.$router.go(-1);
                });
            }
        },
        // 
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if(valid) {
                    createComponents({
                        activity_id:this.form.activity_id,
                        params:JSON.stringify(this.qrCodeObj)
                    }).then(res=>{
                         this.form['components'] = res.components;
                          this.save();
                    });
                   
                } else {
                    this.$message.warning('请检查数据是否为空？');
                    return false;
                }
            });
        },
        pullData(){
            this.$showLoading();
            
            let obj = {};
            if(this.$route.query.id){
                obj['id'] = this.$route.query.id;
                getPoster(obj).then((data)=>{
                    if(data.error >0){
                        this.$message(data.msg);
                        return;
                    }
                    parseComponents({
                        activity_id:data.item.activity_id,
                        components:data.item.components
                    }).then(res=>{
                        this.qrCodeObj = JSON.parse(res.params)?JSON.parse(res.params):{};
                    });
                    this.form.id = data.item.id;
                    this.form.name = data.item.name;
                    this.form.activity_id = data.item.activity_id;
                    this.form.status = data.item.status;
                    this.form.sort = data.item.sort;
                    this.form.image_id = data.item.image_id;
                    this.bgImg = data.item.image_url;
                    this.$hideLoading();
                }).catch((err)=>{
                    this.$hideLoading();
                });
            }
            if(this.activityArr.length==0){
                activityAll().then(data=>{
                    if(data.error >0){
                        this.$message(data.msg);
                        return;
                    }
                    this.activityArr = data.list;

                });
            }
            this.$hideLoading();
        },
        beforeAvatarUpload(file) {
            const isJPG = true;
            const isLt2M = file.size / 1024/ 1024  < 1;

            if (!file.type === 'image/jpg' || !file.type === 'image/png' || !file.type === 'image/gif' ) {
                isJPG = false;
                this.$message.error('上传头像图片只能是 jpg/png/gif 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 1MB!');
            }
            return isJPG && isLt2M;
        },
        uploadImg(param){
            // FormData 对象
            let form = new FormData();
            // 文件对象
            form.append("image", param.file);
            // 携带当前讲座的id
            form.append("key", this.$route.path);
            form.append("preserve", 1);

            // 上传图片接口
            upload_image(form).then((data)=>{
                this.$forceUpdate();
                this.bgImg = data.image_url;
                this.form.image_id = data.image_id;
            });
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.special{
    .el-input,.el-textarea{
        width:775px;
    }
    .price{
        width: 500px;
        margin-right: 20px;
    }
}
.previewimage{
    display:block;
    margin: 20px auto auto;
    width: 300px;
    text-align: center;
    border-radius: 8px;
    .error{
        border-radius: 8px;
        background-color: rgba($color: #eeeeee, $alpha: .5);
    }
}

.up-image{
    margin: 20px auto auto;
    width: 187.5px;
    text-align: center;
    border-radius: 8px;
    .error{
        border-radius: 8px;
        background-color: rgba($color: #eeeeee, $alpha: .5);
    }
}
.auto-hour{
    margin-right: 20px;
    border-radius: 4px;
    padding: 8px 0px;
    padding-left: 15px;
}
.el-form-item{
    p{
        color: #999999;
    }
}
</style>
<style lang="scss">
// .special .el-select .el-input.is-disabled .el-input__inner{
//     background: rgba(0,0,0,0.6)!important;
// }
.el-date-editor .el-range-separator{
    width: 7%;
}
</style>
